var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolvevaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    color: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2788 0H21.5583C10.8487 0 0 7.81166 0 23.4458C0 24.6259 0.0524381 25.7941 0.157558 26.9447C0.269193 28.1667 1.3209 29.063 2.54794 29.063H13.48C19.742 29.063 22.616 27.9321 24.3394 26.2924C26.0931 24.6238 27.1087 21.9302 27.3484 17.8127C27.8449 9.281 27.5969 4.32332 27.2788 0Z",
    fill: "#555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1836 28.6806H44.3507C47.5307 28.6806 50.3122 26.4855 50.7541 23.3364C51.9198 15.0299 51.8678 5.58673 51.0864 0H35.0762C35.3888 4.39132 35.6165 9.61238 35.115 18.2293C34.8994 21.9341 34.1202 25.6059 32.1836 28.6806Z",
    fill: "#555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9975 36.3281C46.5482 36.3281 47.5586 37.9452 46.7484 39.2673C41.7799 47.3752 34.0998 51.242 25.371 51.242C14.8905 51.242 7.71752 46.3631 3.73966 39.1629C3.01451 37.8503 4.02833 36.3281 5.5279 36.3281H44.9975Z",
    fill: "#555"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolvevaLogo);
export default __webpack_public_path__ + "static/media/solveva-logo.86abe29bc0b497b5db3cc31c0e52dfa5.svg";
export { ForwardRef as ReactComponent };